import { axiosBase, errorHandler } from "./axios";

const enableBranches = (data: any) => {
  return axiosBase
    .post("branch/enable", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const createBranch = (data: any) => {
  return axiosBase
    .post("branch/create", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const listBranches = (data: any) => {
  return axiosBase
    .get("branch/list", { params: data })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const switchTenant = (data: any) => {
  return axiosBase
    .post("auth/switchTenant", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

export const branchService = {
  enableBranches,
  createBranch,
  listBranches,
  switchTenant,
};
